/**
 * Spec Phase 4 Slice 4E — DockRail.
 *
 * 336px right rail orchestrator. Stacks the docks per brief §4 in
 * canonical order, with Phase 12 BUG-039 adding the IDF Coverage
 * audit dock at the end.
 *
 * Open / closed state is per-dock and persists to localStorage
 * via the spec store.
 */
import React from 'react';
import FrozenClaimsDock from './FrozenClaimsDock';
import FrozenDrawingsDock from './FrozenDrawingsDock';
import ReferenceSignsDock from './ReferenceSignsDock';
import FeatureMapDock from './FeatureMapDock';
import TermWebDock from './TermWebDock';
import ExaminerViewDock from './ExaminerViewDock';
import GlossaryDock from './GlossaryDock';
import IdfCoverageDock from './IdfCoverageDock';

export default function DockRail(): JSX.Element {
  return (
    <div
      className="flex h-full min-h-0 flex-col overflow-y-auto"
      data-testid="spec-dock-rail"
    >
      <FrozenClaimsDock />
      <FrozenDrawingsDock />
      <ReferenceSignsDock />
      <FeatureMapDock />
      <TermWebDock />
      <ExaminerViewDock />
      <GlossaryDock />
      <IdfCoverageDock />
    </div>
  );
}
